/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unstable-nested-components */
import React, {MouseEventHandler, useCallback, useEffect, useRef, useState} from 'react';
import {throttle, debounce} from 'lodash-es';
import {useRouter} from 'next/router';
import {Button, Col, Form, Checkbox, Row, Slider, Statistic, InputNumber} from 'antd';
import {GameRoomInterface} from 'poker-interfaces';
import {observer} from 'mobx-react';
import Keyboard, {KeyboardReactInterface} from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
/* eslint-disable @typescript-eslint/no-use-before-define */
import jss from 'jss';
import preset from 'jss-preset-default';
import classNames from 'classnames';
import useCommon from '@utils/hooks/common';
import {
  PLAYER_ACTION,
  SUIT,
  GAME_MODE,
  UNIT_TYPE,
  getGameEventV3,
  TABLE_ACTIONS,
  ButtonLoadingState,
} from '@constant/game';
import UpperArrow from '@public/images-mobile/game-room/ActionButtons/grey-upper-arrow.svg';
import {AbsolutePosition, BestCombination, PlayerComponent, PokerComponent} from '@interface/index';
import Poker from '@components/Poker';
import NumpadCrossIcon from '@public/images-mobile/game-room/ActionButtons/numpad-close-button.svg';
import BigNumber from 'bignumber.js';
import {TABLET_BREAKPOINT} from '@constant/system';
import ReactSlider from 'react-slider';
import {
  getBestCombinationText,
  getCumulativeOffset,
  getPlayerCurrentMoney,
  getPlayerCurrentBet,
  arePropsEqualExcept,
} from '@utils/index';
import InsurancePanel from '@components/game-room/InsurancePanel';
import styles from './styles';
import MultiUnitStatistic from '../MultiUnitStatistic';
import {GameLogicInterface} from 'poker-interfaces';
import {AutoAction} from 'poker-interfaces/gameLogic/gameLogicInterface';
import {useWhyDidYouUpdate} from 'ahooks';
import CustomPopup from '@components/CustomPopup';
import {LoadingOutlined} from '@ant-design/icons';
// import DesktopSlider from '../DesktopSlider';
import {AnimatePresence, motion} from 'framer-motion';

const FIELDS = {
  BET_OR_RAISE_VALUE: 'betOrRaiseValue',
};

export const ACTION_BUTTON_Z_INDEX = {
  MODAL: 18,
  SLIDER_TOOLTIP: 0,
  NUMPAD: 16, // to be on top of the cards on the table
  INSURANCE_INFO: 17,
  EMOJI_CONTAINER: 12,
  EMOJI_TARGET_SELECT_BACKDROP: 11,
  COMMUNITY_CARD: 4, // lowered it from 10 to be under the numpad
  SCROLLABLE_INDICATOR: 5,
  BUTTONS: 4,
  ALL_IN_LABEL: 15, // on top of handle
  SLIDER_HANDLE: 14,
  SLIDER_CONTAINER: 13,
  SLIDER_MARK: 2,
  LABELS_IN_SLIDER: 1,
  SEND_EMOJI_BUTTON: 5,
};

const TOOLTIP_OFFSET = {
  LEFT: -32,
  // TOP: 60,
  TOP: -14,
};

const buttonMargin = 15;
const sliderStyles = {
  slider: {
    position: 'relative',
    height: 160,
    width: 40,
    padding: 0,
    // TODO hover blue border issue
    // .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
    '& .ant-slider-handle': {
      background:
        'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(352.35deg, #2C3238 5.92%, #494E57 35.35%, #171717 64.79%, #4D5358 94.22%)',
      height: 38,
      width: 50,
      opacity: '1',
      borderRadius: '10px',
      // border: '3px solid #8076FF',
      border: '2px #D8BA5D solid !important',
      zIndex: ACTION_BUTTON_Z_INDEX.SLIDER_HANDLE,
      // transform: 'translate(20%, 50%)',
      filter:
        'drop-shadow(0px 0px 1.5px #FFFFFF) drop-shadow(0px 0px 2.5px rgba(255, 255, 255, 0.5))',
      '&:after': {
        //  TODO: this is the handle's value
        content: props => {
          const {sliderValue, unit} = props;
          if (unit === UNIT_TYPE.BIG_BLIND) return `"${sliderValue.toString()} BB"`;
          return `"$ ${sliderValue.toString()}"`;
        },
        color: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textShadow: '1px 2px 1px #26052C',
        // font: 'normal bold 6px',
        fontSize: 12,
        fontWeight: 800,
      },
    },
    '&.ant-slider': {
      '&:hover .ant-slider-rail': {
        backgroundColor: 'transparent',
      },
    },
    '& .ant-slider-rail': {
      //! this is the slider background
      background:
        'linear-gradient(180deg, rgba(255, 199, 0, 0.25) 0%, rgba(0, 0, 0, 0.25) 16.67%, rgba(9, 9, 9, 0.25) 33.33%, rgba(0, 0, 0, 0.25) 50%, rgba(0, 0, 0, 0.25) 66.67%, rgba(0, 0, 0, 0.25) 83.33%, rgba(0, 0, 0, 0.25) 100%)',
      boxShadow: '0px 0px 5px #000000, inset 0px 0px 10px #000000',
      border: '2px #D8BA5D solid',
      backdropFilter: 'blur(10px)',
      width: '40px',
      bottom: 0,
      height: '105%',
      borderRadius: 10,
    },
    '& .ant-slider-track': {
      //! when you are pulling
      opacity: '76%',
      background: 'transparent !important',
      width: '100%',
      borderRadius: '0px 0px 30px 30px',
    },
    '& .ant-slider-step': {
      display: 'none',
    },
    '& .ant-slider-mark': {
      width: '100%',
      left: 0,
      zIndex: ACTION_BUTTON_Z_INDEX.SLIDER_MARK,
    },
  },
  glowEffectCommon: {
    background:
      'radial-gradient(circle, rgba(255,255,255,1) 0%,rgba(255,255,255,0.6) 20%, rgba(255,255,255,0) 50%)',
    position: 'absolute',
    zIndex: 15, // 14
    mixBlendMode: 'overlay',
    // borderRadius: 50,
    // filter:'blur(18px)',
  },
  sliderHandleGlowEffectTopLeft: props => ({
    extend: 'glowEffectCommon',
    height: 70,
    width: 70,
    // zIndex: ACTION_BUTTON_Z_INDEX.SLIDER_HANDLE,
    animation: '$lightEffect 5s infinite',
    left: -22,
    top: (props.sliderTooltipPosition?.top || 0) - (TOOLTIP_OFFSET.TOP || 0),
  }),
  sliderHandleGlowEffectTopCenter: props => ({
    extend: 'glowEffectCommon',
    height: 80,
    width: 80,
    animation: '$lightEffect 8s infinite',
    top: (props.sliderTooltipPosition?.top || 0) - (TOOLTIP_OFFSET.TOP || 0),
  }),
  sliderHandleGlowEffectBottomCenter: props => ({
    extend: 'glowEffectCommon',
    height: 50,
    width: 50,
    animation: '$lightEffect 4s infinite',
    left: '15px',
    top: (props.sliderTooltipPosition?.top || 0) - (TOOLTIP_OFFSET.TOP || 0),
  }),
  '@keyframes lightEffect': {
    '0%': {
      opacity: 0,
    },
    '25%': {
      opacity: '1',
      filter: 'brightness(150%)',
    },
    '50%': {
      opacity: '0.5',
    },
    '75%': {
      opacity: '1',
    },
    '100%': {
      opacity: 0.5,
    },
    // for moving
    // 'to':{
    //   transform:'translate(50%, 50%);'
    // }
  },
  invisibleContainer: {
    width: 88,
    height: 112,
  },
  sliderHandleTooltip: props => {
    const {sliderContainerPosition, sliderTooltipPosition, sliderValue, minBet, maxBet} = props;
    const SLIDER_AT_BOTTOM_DIFFERENCE = 592;
    const TOOLTIP_POSSIBLE_AREA_HEIGHT = 162;
    const difference = ((sliderValue - minBet) / (maxBet - minBet)) * TOOLTIP_POSSIBLE_AREA_HEIGHT;

    const yOffset = sliderValue === 0 ? TOOLTIP_OFFSET.TOP : TOOLTIP_OFFSET.TOP - difference;
    // console.log(sliderTooltipPosition, 'sliderTooltipPosition')
    // console.log(sliderValue, 'sliderValue')
    return {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 10,
      zIndex: ACTION_BUTTON_Z_INDEX.SLIDER_TOOLTIP,
      position: 'absolute',
      width: 70,
      height: 24,
      bottom: 0,
      transform: `translate(${TOOLTIP_OFFSET.LEFT}px, ${yOffset}px)`,
      background: 'linear-gradient(180deg, #121212 0%, #313131 100%)',
      borderRadius: '20px 0px 0px 20px',
      boxShadow: '0px 0px 5px rgb(193 179 38)',
    };
  },
  sliderContainer: {
    position: 'absolute',
    right: '0%',
    bottom: '35px',
    zIndex: ACTION_BUTTON_Z_INDEX.SLIDER_CONTAINER,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .ant-form-item': {
      margin: 0,
    },
  },
  sliderMask: {
    opacity: '0',
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: ACTION_BUTTON_Z_INDEX.SLIDER_MARK,
  },
  allInLabel: {
    position: 'relative',
    // zIndex: ACTION_BUTTON_Z_INDEX.ALL_IN_LABEL,
    zIndex: 0,
    // marginBottom: '-10px',
    marginBottom: 3,
    textAlign: 'center',
  },
  allInText: {
    width: '100%',
    fontSize: 11,
    color: 'white',
    textAlign: 'center',
  },
  allInImage: {
    marginBottom: '-10px',
    height: 30,
    // '&.isAllIn':{
    //   transform: 'scale(1.2)',
    // }
  },
  allInValue: {
    '& .ant-statistic-content-prefix': {
      marginRight: 0,
    },
  },
  minBetValue: {
    position: 'relative',
    top: -30,
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: -1,
    '& .ant-statistic-content-prefix': {
      marginRight: 0,
    },
  },
  lowerSliderLabel: {
    zIndex: ACTION_BUTTON_Z_INDEX.LABELS_IN_SLIDER,
    textAlign: 'center',
    color: 'white',
    textShadow: '0px 3px 4px black',
    position: 'absolute',
    bottom: '40px',
    width: '100%',
  },
  numpadButton: {
    width: 38,
    height: 35,
    border: 'none',
    background: 'rgb(11 11 11 / 81%)',
    position: 'relative',
    boxShadow: '0px 3px 6px #000000A6',
    opacity: ' 0.83',
    backdropFilter: ' blur(17px)',
    '-webkit-backdrop-filter': ' blur(17px)',
    display: 'flex',
    justifyContent: 'center',
    marginRight: '2px',
  },
  crossIcon: {
    fontSize: 10,
    margin: 10,
    cursor: 'pointer',
  },
  crossIconCol: {
    marginTop: '32px',
  },
  hidden: {
    display: 'none',
  },
  sliderArrowIcon: {
    width: 15,
  },
  temp: {
    display: 'flex',
    flexDirection: 'row',
  },
};

jss.setup(preset());
const sheet = jss.createStyleSheet(sliderStyles, {link: true}).attach();
sheet.update({sliderValue: 0, sliderToolTipPosition: {top: 0, left: 0}});

const getMinBet = (callAmount: number, minBet: number, maxBet: number) => {
  const bigCallAmount = new BigNumber(callAmount);
  const bigMinBet = new BigNumber(minBet);
  const bigMaxBet = new BigNumber(maxBet);

  const result = bigCallAmount.plus(bigMinBet);

  if (result.isGreaterThan(bigMaxBet)) {
    return bigMaxBet.toNumber();
  }
  return result.toNumber();
};

interface CustomizedSliderInterface {
  isHidden: boolean;
  maskOnClick: MouseEventHandler<HTMLDivElement>;
  maxBet: number;
  callAmount: number;
  minBet: number;
  sliderOnChange: (value: number) => void;
  onSliderAfterChange: (value: number) => void;
  sliderValue: number;
  pot: number;
  smallBlind: number;
}
const CustomizedSlider = React.forwardRef((props: CustomizedSliderInterface, ref: any) => {
  const {classes, theme} = useCommon({
    withStyles: styles,
    withTranslation: ['game_room', 'player_action'],
  });
  const {
    isHidden,
    maskOnClick,
    maxBet,
    callAmount,
    minBet,
    sliderOnChange,
    onSliderAfterChange,
    sliderValue,
    pot,
    smallBlind,
  } = props;
  const lightEffectTriggered = true ? sliderValue === maxBet : false;
  const router = useRouter();
  const isDebugView = router && router.query.isDebugView === 'true';
  const isDesktop = theme?.currentStyleFormat?.id === 'desktop';
  const maxAndMinBetEqual = Number(maxBet) === getMinBet(callAmount, minBet, maxBet);

  return (
    <div
      className={classNames(classes.sliderContainer, {
        hidden: maxAndMinBetEqual || isDesktop || isHidden,
      })}
      ref={ref}
    >
      {/* classNames(classes.myPokerCard, classes.hiddenButOccupySpace) */}
      <div className={classes.allInLabel}>
        {/* <div className={sheet.classes.allInText}>{t('all_in')}</div> */}
        <img
          src="/images-mobile/game-room/ActionButtons/all-in-english.webp"
          alt="all-in-image"
          className={classNames(classes.allInImage, {
            // isAllIn: true
          })}
        />
        {/* <MultiUnitStatistic
          className={classes.allInValue}
          valueStyle={{
            width: 70,
            // background:
            //   'linear-gradient(106.01deg, #FBE37D 0%, #DABD60 33.33%, #B3892B 66.67%, #DCBB59 100%)',
            // '-webkit-background-clip': 'text',
            // '-webkit-text-fill-color': 'transparent',
            textAlign: 'center',
            fontWeight: 900,
            textShadow: 'rgb(38, 5, 44) 1px 2px 2px',
            color: '#DCBB59',
            // font: 'italic normal bold 13px/7px Arial Narrow',
            fontSize: 12,
          }}
          value={isDebugView ? 100 : maxBet || 0}
        /> */}
        <Statistic
          className={classes.allInValue}
          valueStyle={{
            width: 70,

            textAlign: 'center',
            fontWeight: 900,
            textShadow: 'rgb(38, 5, 44) 1px 2px 2px',
            color: '#DCBB59',
            fontSize: 12,
          }}
          value={isDebugView ? 100 : maxBet || 0}
        />
      </div>
      <Form.Item name={FIELDS.BET_OR_RAISE_VALUE}>
        {/* Form.Item can only allow one div inside, otherwise cant pass value */}
        <ReactSlider
          className={classes.mySlider}
          thumbClassName={classes.myThumb}
          trackClassName={classes.myTrack}
          max={isDebugView ? 100 : Number(maxBet)}
          // min={isDebugView ? 10 : getMinBet(callAmount, minBet, maxBet)}
          min={isDebugView ? 10 : Number(minBet)}
          renderThumb={(props, state) => (
            <div {...props}>
              <MultiUnitStatistic
                value={state.valueNow}
                valueStyle={{
                  color: 'white',
                  fontSize: 12,
                  fontWeight: 800,
                  textShadow: '1px 2px 1px #26052C',
                }}
              />
            </div>
          )}
          onChange={v => {
            const max = Number(maxBet);
            const min = getMinBet(callAmount, minBet, maxBet);
            // console.log('onChange - v, max, min', v, max, min);
          }}
          step={0.01}
          orientation="vertical"
          invert
          pearling
          // onChange={sliderOnChange}
          onAfterChange={onSliderAfterChange}
          // minDistance={10}
        />
      </Form.Item>
      <MultiUnitStatistic
        className={classes.minBetValue}
        valueStyle={{
          width: 70,
          textAlign: 'center',
          fontWeight: 900,
          textShadow: 'rgb(38, 5, 44) 1px 2px 2px',
          color: '#DCBB59',
          fontSize: 12,
        }}
        value={isDebugView ? 10 : minBet || 0}
      />
    </div>
  );
});

CustomizedSlider.displayName = 'CustomizedSlider';

type WaitForBlindState = 'WAIT_FOR_BLINDS_TRUE' | 'WAIT_FOR_BLINDS_FALSE';

const ActionButtons = (props: {
  loadingAction: ButtonLoadingState;
  playAlInBGM: () => void;
  availableActions: Array<GameLogicInterface.Action>;
  insuranceInfo: GameLogicInterface.Insurance;
  insuranceExpireAt: string;
  myPlayerOrder: number;
  playerOrderInAction: number;
  autoAction: AutoAction;
  maxBet: number;
  minBet: number;
  pot: number;
  myPlayer: PlayerComponent;
  callAmount: number;
  smallBlind: number;
  gameMode: GameLogicInterface.GameType;
  isAllIn: boolean;
  isDisableAllActions: boolean;
  actionKey: string;
  shortcutOptions?: GameRoomInterface.ShortcutOption[];
  setPlayerActionCallback: (params: {
    action: GameLogicInterface.Action;
    [x: string]: any;
  }) => Promise<any>;
  setTableActionCallback: (params: {
    action: GameRoomInterface.TableAction;
    [x: string]: any;
  }) => Promise<any>;
  shouldSlideDownButtons: boolean;
  // setShouldSlideDownButtons: React.Dispatch<React.SetStateAction<boolean>>;
}): JSX.Element => {
  const {classes, t, game, theme} = useCommon({
    withTranslation: ['action_buttons', 'best_combination'],
    withStyles: styles,
    observers: ['game'],
  });

  const {
    loadingAction,
    playAlInBGM,
    availableActions,
    insuranceInfo,
    insuranceExpireAt,
    autoAction,
    myPlayerOrder,
    playerOrderInAction,
    maxBet,
    minBet,
    pot,
    myPlayer,
    callAmount,
    gameMode,
    smallBlind,
    isAllIn,
    isDisableAllActions,
    setPlayerActionCallback,
    setTableActionCallback,
    actionKey,
    shortcutOptions,
    shouldSlideDownButtons,
    // setShouldSlideDownButtons,
  } = props;

  const [form] = Form.useForm();
  const router = useRouter();

  const [isSettingBet, setIsSettingBet] = useState<boolean>(false);
  const [isNumpadShown, setIsNumpadShown] = useState<boolean>(false);
  const [isSliderShown, setIsSliderShown] = useState<boolean>(true);
  const [betOrRaiseValue, setBetOrRaiseValue] = useState<number>(0);
  const [valueToServer, setValueToServer] = useState<number>(0);
  const [waitForBlindState, setWaitForBlindState] = useState<WaitForBlindState>(null);
  const [sliderContainerPosition, setSliderContainerPosition] = useState<AbsolutePosition>();
  const [buttonType, setButtonType] = useState<'ACTION' | 'SHORTCUT' | 'EMOJI'>('ACTION');
  const [isLeftArrowShown, setIsLeftArrowShown] = useState<boolean>(false);
  const [isRightArrowShown, setIsRightArrowShown] = useState<boolean>(true);
  const [isBetValueValid, setIsBetValueValid] = useState<boolean>(true);
  const [isWarned, setIsWarned] = useState<boolean>(false);
  const [isPlayerInAction, setIsPlayerInAction] = useState<boolean>(false);
  const [isFoldPopupVisible, setIsFoldPopupVisible] = useState<boolean>(false);
  const [isActionCoolingDown, setIsActionCoolingDown] = useState<boolean>(false);
  const [convertedValue, setConvertedValue] = useState<number>(0);
  // const [loadingAction, setLoadingAction] = useState<GameLogicInterface.Action | null>(null);

  const keyboardRef = useRef<KeyboardReactInterface | null>(null);
  const sliderContainerRef = useRef<HTMLDivElement>();
  const scrollableDivRef = useRef<HTMLDivElement>();
  const allInAudioRef = useRef<HTMLAudioElement>();

  const isDesktop = theme?.currentStyleFormat?.id === 'desktop';

  // useWhyDidYouUpdate('ActionButtons', {...props});

  const handleScrollBarArrow = (): void => {
    if (!scrollableDivRef.current) return;
    const {scrollWidth, scrollLeft, clientWidth} = scrollableDivRef.current;
    const deadzonePx = 10;
    if (scrollWidth - scrollLeft - clientWidth <= deadzonePx) {
      setIsRightArrowShown(false);
    } else {
      setIsRightArrowShown(true);
    }
    setIsLeftArrowShown(scrollLeft > deadzonePx);
  };

  const debouncedScrollHandler = throttle(handleScrollBarArrow, 20);

  // * getCumulativeOffset can lead to UI crash when user push the slider handle
  // useEffect(() => {
  //   if (!sliderContainerRef?.current) return;
  //   const containerPosition = getCumulativeOffset(sliderContainerRef?.current);
  //   if (
  //     containerPosition.top !== sliderContainerPosition?.top ||
  //     containerPosition.left !== sliderContainerPosition?.left
  //   ) {
  //     setSliderContainerPosition(containerPosition);
  //   }
  // }, [sliderContainerRef?.current]);

  useEffect(() => {
    if (myPlayerOrder !== playerOrderInAction) {
      setIsSettingBet(false);
      setIsPlayerInAction(true);
      setIsSliderShown(false);
      setIsNumpadShown(false);
    } else if (myPlayer?.isFolded) {
      setIsSettingBet(false);
    }

    if (myPlayerOrder === playerOrderInAction) {
      setIsPlayerInAction(false);
      setIsSliderShown(true);
    }
  }, [playerOrderInAction, myPlayer]);

  useEffect(() => {
    const currentState = myPlayer?.isWaitingForBlinds
      ? 'WAIT_FOR_BLINDS_TRUE'
      : 'WAIT_FOR_BLINDS_FALSE';
    setWaitForBlindState(currentState);
  }, [myPlayer]);

  useEffect(() => {
    // TODO in case clients want to hide slider again
    // setIsSliderShown(false);
    setIsSettingBet(false);
    setSliderToBottom();
    setIsNumpadShown(false);
    sheet.update({sliderValue: 0});
  }, [actionKey]);

  useEffect(() => {
    if (isDesktop && game.unit === UNIT_TYPE.BIG_BLIND) {
      const minBetvalueInBB = game.getDisplayValue(getMinBet(callAmount, minBet, maxBet));
      sheet.update({
        sliderValue: minBetvalueInBB,
        unit: UNIT_TYPE.BIG_BLIND,
      });
      setConvertedValue(minBetvalueInBB);
      form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: minBetvalueInBB});
    } else {
      const minBetvalue = getMinBet(callAmount, minBet, maxBet);
      sheet.update({sliderValue: minBetvalue});
      setConvertedValue(minBetvalue);
      form.setFieldValue(FIELDS.BET_OR_RAISE_VALUE, minBetvalue);
    }
  }, [minBet, callAmount, maxBet]);

  useEffect(() => {
    handleScrollBarArrow();
    const scrollBarDiv = scrollableDivRef?.current;
    if (!scrollBarDiv) return () => {};
    scrollBarDiv.addEventListener('scroll', debouncedScrollHandler);
    return () => {
      scrollBarDiv.removeEventListener('scroll', debouncedScrollHandler);
    };
  }, [scrollableDivRef?.current]);

  useEffect(() => {
    const minBetValue = game.getDisplayValue(getMinBet(callAmount, minBet, maxBet));
    let multiUnitbetOrRaiseValue = betOrRaiseValue;
    if (!isDesktop && game?.unit === UNIT_TYPE.BIG_BLIND && !isNumpadShown) {
      multiUnitbetOrRaiseValue = game.getDisplayValue(betOrRaiseValue);
    }
    if (multiUnitbetOrRaiseValue < minBetValue) {
      setIsBetValueValid(false);
      setIsWarned(true);
    } else {
      setIsBetValueValid(true);
      setIsWarned(false);
    }
  }, [betOrRaiseValue, minBet]);

  useEffect(() => {
    if (isDesktop) {
      if (game?.unit === UNIT_TYPE.BIG_BLIND) {
        const currentValue = form.getFieldValue(FIELDS.BET_OR_RAISE_VALUE);
        form.setFieldValue(FIELDS.BET_OR_RAISE_VALUE, game?.getDisplayValue(currentValue));
        // convertNo: prevent desktopGrid displaying an outdated state value, ensure re-render
        setConvertedValue(form.getFieldValue(FIELDS.BET_OR_RAISE_VALUE));
      } else {
        const currentValue = form.getFieldValue(FIELDS.BET_OR_RAISE_VALUE);
        form.setFieldValue(FIELDS.BET_OR_RAISE_VALUE, game?.getUSDValue(currentValue));
        setConvertedValue(form.getFieldValue(FIELDS.BET_OR_RAISE_VALUE));
      }
    }
  }, [game?.unit, form, isDesktop]);

  useEffect(() => {
    // validation for numpad onChange
    // note all vlaue is in usd value
    if (valueToServer < getMinBet(callAmount, minBet, maxBet)) {
      setIsBetValueValid(false);
      setIsWarned(true);
    } else {
      setIsBetValueValid(true);
      setIsWarned(false);
    }
  }, [valueToServer]);

  useEffect(() => {
    keyboardRef?.current?.setInput('0');
    // setBetOrRaiseValue(0);
  }, [isNumpadShown]);

  const isDebugView = router && router.query.isDebugView === 'true';

  const setSliderToBottom = useCallback(() => {
    if (isDesktop && game.unit === UNIT_TYPE.BIG_BLIND) {
      const amountInBB = game.getDisplayValue(getMinBet(callAmount, minBet, maxBet));
      form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: amountInBB});
      setBetOrRaiseValue(amountInBB);
      sheet.update({
        sliderValue: amountInBB,
        unit: UNIT_TYPE.BIG_BLIND,
      });
    } else {
      const calculatedMinBet = getMinBet(callAmount, minBet, maxBet);
      form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: calculatedMinBet});
      setBetOrRaiseValue(calculatedMinBet);
      sheet.update({
        sliderValue: calculatedMinBet,
        unit: UNIT_TYPE.USD,
      });
    }
  }, [isDesktop, game, callAmount, minBet, maxBet, form]);

  const performPlayerAction = async (params: ButtonLoadingState) => {
    if (playerOrderInAction !== myPlayerOrder && !isDebugView) return;
    if (params.value >= maxBet) {
      playAlInBGM();
    }
    if (params.value > 0 && params.value < getMinBet(callAmount, minBet, maxBet)) {
      return;
    }

    // console.log('performPlayerAction', params);
    const resp: any = await setPlayerActionCallback({
      ...params,
      action: params.action,
    });
    // TODO @@ seems no resp at all
    console.log(' %%%%%%%%%%%%%%%%%% resp %%%%%%%%%%%%%%%%%%', resp);

    if (resp.success) {
      // setIsButtonPressed(true);
      setSliderToBottom();
      setIsSettingBet(false);
      setIsSliderShown(false);
      setIsNumpadShown(false);

      // Prevent UI bug if call button is clicked too frequently
      setIsActionCoolingDown(true);
      await new Promise(resolve => {
        setTimeout(() => resolve(null), 500);
      });
      setIsActionCoolingDown(false);
    }
  };

  const cancelInsurance = useCallback(async () => {
    await setPlayerActionCallback({
      action: PLAYER_ACTION.CANCEL_INSURANCE,
    });
  }, [setPlayerActionCallback]);

  const confirmInsurance = useCallback(
    async (data: GameLogicInterface.BuyInsurance) => {
      await setPlayerActionCallback({
        action: PLAYER_ACTION.CONFIRM_INSURANCE,
        ...data,
      });
    },
    [setPlayerActionCallback]
  );

  const isActionButtonDisabled = (inputAction: GameLogicInterface.Action): boolean => {
    if (isDebugView) return false;
    if (isDisableAllActions || isActionCoolingDown) return true;
    if (playerOrderInAction !== myPlayerOrder) return true;
    const foundAction = availableActions?.find(actionType => actionType === inputAction);
    if (!foundAction) return true;
    return false;
  };

  const isRaiseAvailable =
    Array.isArray(availableActions) && availableActions?.includes(PLAYER_ACTION.RAISE);
  const isRaiseDisabled = isActionButtonDisabled(PLAYER_ACTION.RAISE);
  const isBetDisabled = isActionButtonDisabled(PLAYER_ACTION.BET);

  const BetOrRaiseButton = React.memo(
    ({
      buttonType,
      className,
    }: {
      buttonType: GameLogicInterface.Action | 'ALL_IN';
      className?: string;
    }) => (
      <Button
        className={classNames(classes.keyboardOrNumpadButton, className)}
        onClick={() => {
          if (buttonType === 'ALL_IN') {
            performPlayerAction({
              action: isRaiseAvailable ? PLAYER_ACTION.RAISE : PLAYER_ACTION.BET,
              value: maxBet,
            });
            // playAllInAnimation();
            setIsSliderShown(!isSliderShown);
          } else {
            // TODO in case clients want to hide slider again
            // setIsSettingBet(true);
            setSliderToBottom();
            setIsSliderShown(!isSliderShown);
          }
        }}
        disabled={isRaiseDisabled && isBetDisabled}
      >
        <div
          className={classNames(classes.buttonContent, {
            isClicked: isSliderShown,
          })}
        >
          <img
            src="/images-mobile/game-room/ActionButtons/slider-button.svg"
            className={classes.sliderIcon}
            alt=""
          />
        </div>
      </Button>
    )
  );
  BetOrRaiseButton.displayName = 'BetOrRaiseButton';

  const KeyboardButton = React.memo(
    ({
      buttonType,
      className,
    }: {
      buttonType: GameLogicInterface.Action | 'ALL_IN';
      className?: string;
    }) => (
      <Button
        className={classNames(classes.keyboardOrNumpadButton, className)}
        onClick={() => {
          if (buttonType === 'ALL_IN') {
            performPlayerAction({
              action: isRaiseAvailable ? PLAYER_ACTION.RAISE : PLAYER_ACTION.BET,
              value: maxBet,
            });
            // playAllInAnimation();
            setIsNumpadShown(!isNumpadShown);
          } else {
            setIsSettingBet(true);
            setSliderToBottom();
            setIsNumpadShown(!isNumpadShown);
            setBetOrRaiseValue(0); // set numpadDisplayField to 0
          }
        }}
        disabled={isRaiseDisabled && isBetDisabled}
      >
        <div
          className={classNames(classes.buttonContent, {
            isClicked: isNumpadShown,
          })}
        >
          <img
            src="/images-mobile/game-room/ActionButtons/keyboard-button.svg"
            className={classes.keyboardIcon}
            alt=""
          />
        </div>
      </Button>
    )
  );
  KeyboardButton.displayName = 'KeyboardButton';

  interface CallButtonProps {
    callAmount: number;
    myPlayer: PlayerComponent;
  }

  const CallButton = React.memo((propsLocal?: CallButtonProps) => {
    const {callAmount, myPlayer} = propsLocal;

    const displayValue =
      myPlayer && callAmount > myPlayer.remainingMoney
        ? myPlayer.remainingMoney
        : myPlayer && myPlayer?.currentBet !== 0 && !Number.isNaN(myPlayer?.currentBet)
        ? callAmount - myPlayer.currentBet
        : callAmount;

    // TODO @@ call button
    return (
      <Button
        id="callButton"
        className={classNames(classes.callButton, {
          [classes.hidden]: isActionButtonDisabled('CALL'),
          callButtonLoading: loadingAction?.action === PLAYER_ACTION.CALL,
        })}
        onClick={() => {
          performPlayerAction({action: PLAYER_ACTION.CALL});
        }}
        disabled={isActionButtonDisabled(PLAYER_ACTION.CALL)}
      >
        <div className={classes.callButtonDiv}>
          <div
            className={classNames(classes.callButtonLabel, {
              callButtonLoading: loadingAction?.action === PLAYER_ACTION.CALL,
            })}
          >
            {t('call')}
            {loadingAction?.action === PLAYER_ACTION.CALL ? (
              <LoadingOutlined style={{marginLeft: 5}} />
            ) : (
              <div className={classes.callAmountLabel}>
                {displayValue > 0 && (
                  <>
                    (
                    <MultiUnitStatistic
                      value={displayValue}
                      valueStyle={{
                        color: '#FFFFFF',
                        fontSize: '12px',
                      }}
                    />
                    )
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </Button>
    );
  });

  CallButton.displayName = 'CallButton';

  const AllInButton = React.memo(() => (
    <Button
      id="allInButton"
      className={classes.allInButton}
      onClick={() => {
        performPlayerAction({action: PLAYER_ACTION.ALL_IN});
      }}
      disabled={isActionButtonDisabled(PLAYER_ACTION.ALL_IN)}
    >
      <div className={classes.buttonLabel}>{t('all_in')}</div>
    </Button>
  ));
  AllInButton.displayName = 'AllInButton';

  const FoldButton = React.memo(() => (
    <Button
      id="foldButton"
      className={classNames(classes.foldButton, {
        loading: loadingAction?.action === PLAYER_ACTION.FOLD,
      })}
      onClick={() => {
        // if last player check then show pop up when fold
        if (!isActionButtonDisabled('CHECK')) {
          setIsFoldPopupVisible(true);
        } else {
          performPlayerAction({action: PLAYER_ACTION.FOLD});
        }
      }}
      disabled={isActionButtonDisabled(PLAYER_ACTION.FOLD)}
    >
      <div
        className={classNames(classes.foldButtonLabel, {
          loading: loadingAction?.action === PLAYER_ACTION.FOLD,
        })}
      >
        {t('fold')}
        {loadingAction?.action === PLAYER_ACTION.FOLD && (
          <LoadingOutlined style={{marginLeft: 5}} />
        )}
      </div>
    </Button>
  ));
  FoldButton.displayName = 'FoldButton';

  const CheckButton = React.memo(() => (
    <Button
      id="checkButton"
      className={classNames(
        classes.checkButton,
        !isActionButtonDisabled('CALL') && classes.hidden,
        !isActionButtonDisabled('CALL') && !isActionButtonDisabled('CHECK') && 'visible',
        {
          checkButtonLoading: loadingAction?.action === PLAYER_ACTION.CHECK,
        }
      )}
      onClick={() => {
        performPlayerAction({action: PLAYER_ACTION.CHECK});
      }}
      // TODO @@ may need to un-comment
      // disabled={isActionButtonDisabled(PLAYER_ACTION.CHECK)}
    >
      <div
        className={classNames(classes.checkButtonLabel, {
          checkButtonLoading: loadingAction?.action === PLAYER_ACTION.CHECK,
        })}
      >
        {t('check')}
        {loadingAction?.action === PLAYER_ACTION.CHECK && (
          <LoadingOutlined style={{marginLeft: 5}} />
        )}
      </div>
    </Button>
  ));
  CheckButton.displayName = 'CheckButton';

  const CallAnyButton = React.memo(() => (
    <Button
      className={classNames(classes.callAnyButton, {
        [classes.checkedCallAnyButton]: myPlayer?.autoAction === 'CALL_ANY',
      })}
      onClick={() => {
        setAutoAction('CALL_ANY');
      }}
    >
      <div
        className={
          autoAction === 'CALL_ANY' ? classes.checkedCallAnyButtonLabel : classes.buttonLabel
        }
      >
        <span className={`${classes.persistentActionButton}Text`}>{t('call_any')}</span>
      </div>
    </Button>
  ));
  CallAnyButton.displayName = 'CallAnyButton';

  const ShortcutButton = React.memo(
    (shortcutProps: {options: GameRoomInterface.ShortcutOption[]}) => {
      const {options} = shortcutProps;
      const getAmountText = (item: GameRoomInterface.ShortcutOption) => {
        const {unitValue, unit} = item;
        if (unit === 'MAX') {
          return t('max');
        }
        if (unit === 'POT') {
          return t('pot');
        }
        if (unit === 'POT_PERCENT') {
          return `${unitValue}%`;
        }
        if (unit === 'BB') {
          return unitValue + t('player_action:bb');
        }
        return null;
      };

      const getActionText = (item: GameRoomInterface.ShortcutOption) => {
        if (item.betValue >= maxBet) {
          return <span className={`${classes.shortcutButton}MinMax`}>{t('max')}</span>;
        }
        if (isRaiseAvailable) {
          return <span className={`${classes.shortcutButton}Text`}>{t('raise')} </span>;
        }
        return <span className={`${classes.shortcutButton}Text`}>{t('bet')} </span>;
      };

      return (
        <div
          id="shortcutContainer"
          className={classNames(
            `${classes.shortcutButton}Container`,
            isActionButtonDisabled(PLAYER_ACTION.RAISE) &&
              isActionButtonDisabled(PLAYER_ACTION.BET) &&
              'hidden'
          )}
        >
          {options?.map((item, key) => {
            // console.log('item', item);
            const isButtonLoading =
              (loadingAction?.action === PLAYER_ACTION.BET ||
                loadingAction?.action === PLAYER_ACTION.RAISE) &&
              loadingAction?.value === item.betValue &&
              loadingAction?.unit === item.unit &&
              loadingAction?.unitValue === item.unitValue;

            return (
              <Button
                key={key}
                className={classNames(classes.shortcutButton, {
                  loading: isButtonLoading,
                })}
                // className={classes.shortcutButton}
                onClick={() => {
                  if (!isDesktop) {
                    performPlayerAction({
                      action: isRaiseAvailable ? PLAYER_ACTION.RAISE : PLAYER_ACTION.BET,
                      value: item.betValue,
                      unit: item.unit,
                      unitValue: item.unitValue,
                    });
                  } else if (game?.unit === UNIT_TYPE.BIG_BLIND) {
                    form.setFieldValue(
                      FIELDS.BET_OR_RAISE_VALUE,
                      game?.getDisplayValue(item.betValue)
                    );
                    setBetOrRaiseValue(game?.getDisplayValue(item.betValue));
                  } else {
                    form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: item.betValue});
                    setBetOrRaiseValue(item.betValue);
                  }
                }}
                disabled={
                  isActionButtonDisabled(PLAYER_ACTION.RAISE) &&
                  isActionButtonDisabled(PLAYER_ACTION.BET)
                }
              >
                <div
                  className={classNames(classes.shortcutButtonLabel, {
                    loading: isButtonLoading,
                  })}
                >
                  <div className={`${classes.shortcutButton}Wrap`}>
                    <div className={`${classes.shortcutButton}Tag`}>
                      <span className={`${classes.shortcutButton}BB`}>{getAmountText(item)}</span>
                    </div>
                    <div className={`${classes.shortcutButton}Column`}>
                      {getActionText(item)}
                      <MultiUnitStatistic
                        value={item.betValue}
                        valueStyle={{
                          color: '#FFFFFF',
                          fontSize: isDesktop ? 'clamp(10px, 0.5vw, 15px)' : '12px',
                          lineHeight: isDesktop ? '20px' : '12px',
                        }}
                      />
                    </div>
                  </div>
                  {isButtonLoading && <LoadingOutlined style={{marginLeft: 5}} />}
                </div>
              </Button>
            );
          })}
        </div>
      );
    }
  );

  ShortcutButton.displayName = 'ShortcutButton';

  const CheckOrFoldButton = React.memo(() => (
    <Button
      className={classNames(classes.checkOrFoldButton, {
        [classes.checkedCheckOrFoldButton]: autoAction === 'CHECK_FOLD',
      })}
      onClick={() => {
        setAutoAction('CHECK_FOLD');
      }}
    >
      <div
        className={
          autoAction === 'CHECK_FOLD' ? classes.checkedCheckOrFoldButtonLabel : classes.buttonLabel
        }
      >
        <span className={`${classes.persistentActionButton}Text`}>{t('check_or_fold')}</span>
      </div>
    </Button>
  ));
  CheckOrFoldButton.displayName = 'CheckOrFoldButton';

  const PersistentFoldButton = React.memo(() => (
    <Button
      className={classNames(classes.persistentActionButton, {
        [classes.checkedPersistentButton]: autoAction === 'CHECK_FOLD',
      })}
      onClick={() => {
        setAutoAction('CHECK_FOLD');
      }}
    >
      <div
        className={autoAction === 'CHECK_FOLD' ? classes.checkedButtonLabel : classes.buttonLabel}
      >
        <span className={`${classes.persistentActionButton}Text`}>{t('fold')}</span>
      </div>
    </Button>
  ));
  PersistentFoldButton.displayName = 'PersistentFoldButton';

  const PersistentAllInButton = React.memo(() => (
    <Button
      className={classNames(classes.persistentActionButton, {
        [classes.checkedPersistentButton]: autoAction === 'ALL_IN',
      })}
      onClick={() => {
        setAutoAction('ALL_IN');
      }}
    >
      <div className={autoAction === 'ALL_IN' ? classes.checkedButtonLabel : classes.buttonLabel}>
        <span className={`${classes.persistentActionButton}Text`}>{t('all_in')}</span>
      </div>
    </Button>
  ));
  PersistentAllInButton.displayName = 'PersistentAllInButton';

  const toggleWaitForBlinds = () => {
    const toggledState = myPlayer?.isWaitingForBlinds
      ? 'WAIT_FOR_BLINDS_FALSE'
      : 'WAIT_FOR_BLINDS_TRUE';
    setWaitForBlindState(toggledState);
    setTableActionCallback({
      action: toggledState,
    });
  };

  const setAutoActionRequest = (action: AutoAction) => {
    setTableActionCallback({
      action: 'SET_AUTO_ACTION',
      params: {
        autoAction: action || null,
      },
    });
  };

  const setAutoAction = (action: AutoAction) => {
    if (action === autoAction) {
      setAutoActionRequest(null);
    } else {
      setAutoActionRequest(action);
    }
  };

  const WaitForBlindsButton = React.memo(() => (
    <Button
      className={classNames(classes.waitForBlindButton, {
        [classes.checkedWaitForBlindButton]: waitForBlindState === 'WAIT_FOR_BLINDS_TRUE',
      })}
      onClick={() => {
        toggleWaitForBlinds();
      }}
    >
      <div
        className={
          waitForBlindState === 'WAIT_FOR_BLINDS_TRUE'
            ? classes.checkedWaitForBlindLabel
            : classes.waitForBlindButtonLabel
        }
      >
        <span className={`${classes.persistentActionButton}Text`}>{t('wait_for_blinds')}</span>
      </div>
    </Button>
  ));
  WaitForBlindsButton.displayName = 'WaitForBlindsButton';

  const JoinDirectlyButton = React.memo(() => (
    <Button
      className={classNames(classes.joinDirectlyButton, {
        [classes.checkedJoinDirectlyButton]: waitForBlindState === 'WAIT_FOR_BLINDS_FALSE',
      })}
      onClick={() => {
        toggleWaitForBlinds();
      }}
    >
      <div
        className={
          waitForBlindState === 'WAIT_FOR_BLINDS_FALSE'
            ? classes.checkedJoinDirectlyButtonLabel
            : classes.joinDirectlyButtonLabel
        }
      >
        <span className={`${classes.persistentActionButton}Text`}>{t('join_directly')}</span>
      </div>
    </Button>
  ));
  JoinDirectlyButton.displayName = 'JoinDirectlyButton';

  const truncateByDecimalPlace = (value: number, numDecimalPlaces: number): number =>
    Math.trunc(value * Math.pow(10, numDecimalPlaces)) / Math.pow(10, numDecimalPlaces);

  const PlaceBetButton = React.memo(() => (
    <Button
      className={classes.placeBetButton}
      disabled={(isRaiseDisabled && isBetDisabled) || !isBetValueValid}
      onClick={() => {
        // TODO
        // if useState, value seems to be in closure
        BigNumber.config({
          DECIMAL_PLACES: 2,
          ROUNDING_MODE: BigNumber.ROUND_HALF_UP,
        });
        const value = form.getFieldValue(FIELDS.BET_OR_RAISE_VALUE);
        let truncatedValue: number;

        if (game.unit === UNIT_TYPE.BIG_BLIND && !isSliderShown && !isDesktop) {
          const valueInBB = new BigNumber(truncateByDecimalPlace(value, 2))
            .multipliedBy(game.bigBlind)
            .toNumber();
          truncatedValue = truncateByDecimalPlace(valueInBB, 2);
        } else if (game.unit === UNIT_TYPE.BIG_BLIND && !isSliderShown && isDesktop) {
          const valueInBB = new BigNumber(truncateByDecimalPlace(value, 2))
            .multipliedBy(game.bigBlind)
            .toNumber();
          truncatedValue = truncateByDecimalPlace(valueInBB, 2);
        } else if (game.unit === UNIT_TYPE.USD) {
          truncatedValue = truncateByDecimalPlace(value, 2);
        } else if (game.unit === UNIT_TYPE.BIG_BLIND) {
          truncatedValue = truncateByDecimalPlace(value, 2);
        }
        console.log('# value to server # ', truncatedValue);

        if (isSettingBet || isDesktop) {
          if (isRaiseAvailable) {
            performPlayerAction({
              action: PLAYER_ACTION.RAISE,
              value: truncatedValue >= maxBet ? maxBet : truncatedValue,
            });
          } else {
            performPlayerAction({
              action: PLAYER_ACTION.BET,
              value: truncatedValue >= maxBet ? maxBet : truncatedValue,
            });
          }
        }
        if (value === maxBet) {
          // playAllInAnimation();
        }
        setBetOrRaiseValue(0);
        keyboardRef?.current?.setInput('');
        setIsSliderShown(false);
        setIsNumpadShown(false);
      }}
    >
      {/* TODO play coins video/gif */}
      <div className={classes.buttonLabel}>{t('place_bet')}</div>
    </Button>
  ));
  PlaceBetButton.displayName = 'PlaceBetButton';

  const renderBetOrRaise = useCallback(() => {
    if (!myPlayer || isAllIn || isDesktop || shouldSlideDownButtons) {
      return null;
    }
    if (
      callAmount >= myPlayer.remainingMoney + myPlayer.currentBet ||
      callAmount >= maxBet ||
      callAmount + minBet >= myPlayer.remainingMoney + myPlayer.currentBet
    ) {
      return null;
    }

    if (!isRaiseDisabled) {
      return (
        <>
          <KeyboardButton buttonType={PLAYER_ACTION.RAISE} />
          <BetOrRaiseButton buttonType={PLAYER_ACTION.RAISE} />
        </>
      );
    }
    if (!isBetDisabled) {
      return (
        <>
          <KeyboardButton buttonType={PLAYER_ACTION.BET} />
          <BetOrRaiseButton buttonType={PLAYER_ACTION.BET} />
        </>
      );
    }
    return (
      <>
        <KeyboardButton buttonType={PLAYER_ACTION.BET} className={classes.hiddenButOccupySpace} />
        <BetOrRaiseButton buttonType={PLAYER_ACTION.BET} className={classes.hiddenButOccupySpace} />
      </>
    );
  }, [
    isSliderShown,
    isNumpadShown,
    isRaiseDisabled,
    isBetDisabled,
    gameMode,
    minBet,
    maxBet,
    myPlayer,
    callAmount,
    isDesktop,
    shouldSlideDownButtons,
  ]);

  useEffect(() => {
    // prevent ui bug when windows change form desktop view to mobile view
    setSliderToBottom();
    if (!isDesktop) {
      setIsSettingBet(false);
    } else {
      setIsSettingBet(true);
      setIsSliderShown(false);
      setIsNumpadShown(false);
    }
  }, [isDesktop]);

  useEffect(() => {
    if (isDesktop) {
      setIsSettingBet(true);
    }
  }, []);

  interface DesktopSliderInterface {
    pot: number;
    maxBet: number;
    callAmount: number;
    minBet: number;
    smallBlind: number;
    sliderValue?: number;
    isRaiseDisabled: boolean;
    isBetDisabled: boolean;
    convertedNo?: number;
  }

  const DesktopSlider = React.memo((props: DesktopSliderInterface): JSX.Element => {
    const {
      maxBet,
      callAmount,
      minBet,
      pot,
      smallBlind,
      sliderValue,
      isRaiseDisabled,
      isBetDisabled,
      convertedNo,
    } = props;

    setBetOrRaiseValue(Number(sliderValue));
    const calculatedMinBet = getMinBet(callAmount, minBet, maxBet);

    const lightEffectTriggered = true ? betOrRaiseValue === maxBet : false;
    const sameMinMaxTriggered = true ? calculatedMinBet === maxBet : false;

    const handleSliderOnChange = value => {
      form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: Number(value)});
      setBetOrRaiseValue(Number(value));
    };

    return (
      <div className={classes.sliderWrap}>
        <Slider
          className={classNames(
            isRaiseDisabled && isBetDisabled && classes.hiddenButOccupySpace,
            sameMinMaxTriggered && classes.sameMinMaxTriggered,
            classes.desktopSlider
          )}
          min={calculatedMinBet}
          max={maxBet}
          step={0.01}
          onAfterChange={value => handleSliderOnChange(value)}
          disabled={isRaiseDisabled && isBetDisabled}
          defaultValue={sliderValue}
          // getTooltipPopupContainer={node => node.parentNode}
        />
        <div
          className={classNames(
            isRaiseDisabled && isBetDisabled && classes.hiddenButOccupySpace,
            classes.allInDiv
          )}
        >
          <div className={classes.buttonText} data-text={t('all_in')} />
        </div>
      </div>
    );
  });
  DesktopSlider.displayName = 'DesktopSlider';

  const InputArea = React.memo((props?: any) => {
    const {maxBet, callAmount, minBet, pot, smallBlind, inputValue} = props;

    const calculatedMinBet = getMinBet(callAmount, minBet, maxBet);
    const handleChange = debounce(val => {
      setIsSettingBet(true);
      form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: Number(val)});
      setBetOrRaiseValue(Number(val));
    }, 100);

    return (
      <div
        className={classNames(
          isRaiseDisabled && isBetDisabled && classes.hiddenButOccupySpace,
          classes.inputAreaWrap
        )}
      >
        <Form.Item name={FIELDS.BET_OR_RAISE_VALUE}>
          <InputNumber
            className={isWarned ? classes.inputAreaWithWaring : classes.inputArea}
            controls={false}
            // value={typeof betOrRaiseValue === 'number' ? betOrRaiseValue : calculatedMinBet}
            max={maxBet}
            min={calculatedMinBet}
            disabled={isRaiseDisabled && isBetDisabled}
            // onChange={val => {
            //   handleChange(val);
            // }}
            onChange={handleChange}
            addonBefore={game.unit === UNIT_TYPE.USD ? '$' : null}
            addonAfter={game.unit === UNIT_TYPE.BIG_BLIND ? 'BB' : null}
            keyboard={false}
            step={smallBlind}
            value={inputValue}
            style={{color: 'black'}}
            // autoFocus
          />
        </Form.Item>
      </div>
    );
  });
  InputArea.displayName = 'InputArea';

  const DesktopButtonGrid = React.memo((props?: any) => {
    const {maxBet, callAmount, minBet, pot, smallBlind, shortcutOptions, myPlayer, convertedNo} =
      props;
    const displayPot = game.getDisplayValue(pot);
    const displayMaxBet = game.getDisplayValue(maxBet);
    const displayCallAmount = game.getDisplayValue(callAmount);
    const displayMinBet = game.getDisplayValue(minBet);
    const displaySmallBlind = game.getDisplayValue(smallBlind);

    const currentValue = form.getFieldValue(FIELDS.BET_OR_RAISE_VALUE);

    return (
      <>
        <div className={classes.sliderRow}>
          <DesktopSlider
            pot={displayPot}
            maxBet={displayMaxBet}
            callAmount={displayCallAmount}
            minBet={displayMinBet}
            smallBlind={displaySmallBlind}
            isRaiseDisabled={isRaiseDisabled}
            isBetDisabled={isBetDisabled}
            sliderValue={currentValue}
            convertedNo={convertedNo}
          />
        </div>
        <div className={classes.firstButtonRow}>
          <ShortcutButton options={shortcutOptions} />
          <InputArea
            pot={displayPot}
            maxBet={displayMaxBet}
            callAmount={displayCallAmount}
            minBet={displayMinBet}
            smallBlind={displaySmallBlind}
            inputValue={betOrRaiseValue}
          />
        </div>
        <div className={classes.secondButtonRow}>
          <FoldButton />
          <CheckButton />
          <CallButton callAmount={callAmount} myPlayer={myPlayer} />
          <PlaceBetButton />
        </div>
      </>
    );
  });
  DesktopButtonGrid.displayName = 'DesktopButtonGrid';

  const renderButtons = () => {
    const actionButtons: JSX.Element[] = [];
    const persistentActions: JSX.Element[] = [];
    if (isAllIn) {
      actionButtons.push(<FoldButton />, <AllInButton />);
      persistentActions.push(<PersistentFoldButton />, <PersistentAllInButton />);
    } else {
      // eslint-disable-next-line max-len
      actionButtons.push(
        <FoldButton />,
        <CheckButton />,
        <CallButton callAmount={callAmount} myPlayer={myPlayer} />,
        <ShortcutButton options={shortcutOptions} />
      );
      persistentActions.push(<CheckOrFoldButton />, <CallAnyButton />);
    }

    if (myPlayer?.needWaitForBlinds) {
      return (
        <div className={classes.waitForBlindButtonContainer}>
          <WaitForBlindsButton />
          <JoinDirectlyButton />
        </div>
      );
    }

    const renderDesktopButtons = () => {
      return (
        <DesktopButtonGrid
          pot={pot}
          maxBet={maxBet}
          callAmount={callAmount}
          minBet={minBet}
          smallBlind={smallBlind}
          shortcutOptions={shortcutOptions}
          myPlayer={myPlayer}
        />
      );
    };

    const renderButtonsRow = () => {
      return (
        // TODO @@ refactor
        <motion.div
          animate={shouldSlideDownButtons ? {y: 500} : {y: 0}}
          transition={{type: 'spring', duration: 1, bounce: 0.2}}
          className={classNames({
            [classes.buttonsRowAllinScrollable]: isAllIn && isDesktop,
            [classes.buttonsRowScrollable]: !(isAllIn && isDesktop),
          })}
        >
          {!isAllIn && isDesktop ? renderDesktopButtons() : actionButtons}
        </motion.div>
      );
    };
    const renderActionButtons = () => {
      if (isPlayerInAction && !isDebugView)
        return <div className={classes.persistentButtonRow}>{persistentActions}</div>;
      return renderButtonsRow();
    };

    return (
      <>
        <div
          className={classNames(classes.buttonsRow, {
            [classes.actionButtonHidden]:
              isDesktop || (!isDesktop && !isSettingBet) || isDisableAllActions,
          })}
        >
          <PlaceBetButton />
        </div>
        <div
          ref={scrollableDivRef}
          className={classNames(classes.buttonsRowScrollableContainer, {
            [classes.hiddenButOccupySpace]:
              isDisableAllActions ||
              myPlayer?.isFolded ||
              myPlayer?.isAllIn ||
              !myPlayer?.isActive ||
              myPlayer.needWaitForBlinds,
            [classes.actionButtonHidden]: (!isDesktop && isSettingBet) || buttonType !== 'ACTION',
            [classes.slideUp]: !isPlayerInAction,
          })}
        >
          <div className={classes.buttonsRowScrollableLongDiv}>
            {!isDisableAllActions && renderActionButtons()}
          </div>
        </div>
      </>
    );
  };

  const getSliderNumpadClass = (): string => {
    if (isDisableAllActions) return null;
    return classes.sliderNumpadDiv;
  };

  const sliderMaskOnClick = useCallback(() => {
    setIsSettingBet(false);
    setSliderToBottom();
    setIsSliderShown(false);
    setIsNumpadShown(false);
    sheet.update({sliderValue: 0});
  }, [setSliderToBottom]);

  const sliderOnChange = useCallback(
    val => {
      form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: val});
      setBetOrRaiseValue(val);
    },
    [form]
  );

  const onSliderAfterChange = useCallback(
    value => {
      BigNumber.config({
        DECIMAL_PLACES: 2,
        ROUNDING_MODE: BigNumber.ROUND_HALF_UP,
      });
      let truncatedValue: number;

      console.log('@@ onSliderAfterChange - value, maxBet, minBet', value, maxBet, minBet);
      if (value === minBet) {
        console.log(' slider bottom => cancel ');
        return;
      }

      if (game.unit === UNIT_TYPE.BIG_BLIND && !isSliderShown && !isDesktop) {
        const valueInBB = new BigNumber(truncateByDecimalPlace(value, 2))
          .multipliedBy(game.bigBlind)
          .toNumber();
        truncatedValue = truncateByDecimalPlace(valueInBB, 2);
      } else if (game.unit === UNIT_TYPE.BIG_BLIND && !isSliderShown && isDesktop) {
        const valueInBB = new BigNumber(truncateByDecimalPlace(value, 2))
          .multipliedBy(game.bigBlind)
          .toNumber();
        truncatedValue = truncateByDecimalPlace(valueInBB, 2);
      } else if (game.unit === UNIT_TYPE.USD) {
        truncatedValue = truncateByDecimalPlace(value, 2);
      } else if (game.unit === UNIT_TYPE.BIG_BLIND) {
        truncatedValue = truncateByDecimalPlace(value, 2);
      }
      console.log('# value to server # ', truncatedValue);

      // if (isSettingBet || isDesktop) {
      if (isRaiseAvailable) {
        console.log('perform raise');
        performPlayerAction({
          action: PLAYER_ACTION.RAISE,
          value: truncatedValue >= maxBet ? maxBet : truncatedValue,
        });
      } else {
        console.log('perform bet');
        performPlayerAction({
          action: PLAYER_ACTION.BET,
          value: truncatedValue >= maxBet ? maxBet : truncatedValue,
        });
      }
      // }
      if (value === maxBet) {
        // playAllInAnimation();
      }
      // setBetOrRaiseValue(0);
      keyboardRef?.current?.setInput('');
      setIsNumpadShown(false);
    },
    [
      game.bigBlind,
      game.unit,
      isDesktop,
      isRaiseAvailable,
      isSliderShown,
      maxBet,
      performPlayerAction,
    ]
  );

  if (isDisableAllActions) {
    return null;
  }

  return (
    <>
      <Form
        onValuesChange={value => {
          const valueInNumber = Number(value[FIELDS.BET_OR_RAISE_VALUE]);
          if (valueInNumber > -1) {
            const sliderDOM = document.getElementsByClassName(
              'ant-slider-handle'
            )?.[0] as HTMLElement;
            setBetOrRaiseValue(valueInNumber);
            // * getCumulativeOffset can lead to UI crash when user push the slider handle
            // const sliderHandlePosition = getCumulativeOffset(sliderDOM);
            // TODO lag
            // sheet.update({
            //   sliderValue: game.getDisplayValue(valueInNumber),
            //   sliderTooltipPosition: sliderHandlePosition,
            //   sliderContainerPosition,
            //   minBet: game.getDisplayValue(getMinBet(callAmount, minBet, maxBet)),
            //   maxBet: game.getDisplayValue(maxBet),
            //   unit: game.unit,
            // });
          }
        }}
        form={form}
      >
        <div
          className={classNames(classes.sliderMask, {
            // TODO in case clients want to hide slider again
            // [classes.hidden]: !isSliderShown || isDisableAllActions,
            [classes.hidden]: true,
          })}
          onClick={() => {
            setIsSettingBet(false);
            setSliderToBottom();
            setIsSliderShown(false);
            setIsNumpadShown(false);
            sheet.update({sliderValue: 0});
          }}
        />
        <div
          className={classNames(classes.numpadMask, {
            [classes.hidden]: !isNumpadShown || isDisableAllActions || !isSettingBet,
          })}
          onClick={() => {
            setIsSettingBet(false);
            setSliderToBottom();
            setIsNumpadShown(false);
            setIsSliderShown(false);
            sheet.update({sliderValue: 0});
          }}
        />
        <div className={getSliderNumpadClass()}>
          <div
            className={
              classNames()
              // TODO lag, check if these code are needed
              // (!myPlayer || isDesktop) && classes.hidden,
              // isNumpadShown && classes.sliderColumnWithNumPadOpen,
              // !isPlayerInAction && classes.sliderSlideUpAnimation,
              // !isNumpadShown && classes.sliderColumn // TODO
            }
          >
            {/* // TODO @@ refactor  */}
            <motion.div
              className={classNames(classes.raiseBetButtonContainer, {})}
              animate={shouldSlideDownButtons || myPlayer?.isFolded ? {y: 500} : {y: 0}}
              transition={{type: 'spring', duration: 1, bounce: 0.2}}
            >
              <CustomizedSlider
                // ref={sliderContainerRef}
                // TODO in case clients want to hide slider again
                // isHidden={!isSliderShown || isDisableAllActions || !isSettingBet}
                isHidden={
                  !isSliderShown ||
                  shouldSlideDownButtons ||
                  isDisableAllActions ||
                  (isActionButtonDisabled(PLAYER_ACTION.RAISE) &&
                    isActionButtonDisabled(PLAYER_ACTION.BET))
                }
                // isHidden={false}
                maskOnClick={sliderMaskOnClick}
                sliderOnChange={sliderOnChange}
                onSliderAfterChange={onSliderAfterChange}
                pot={pot}
                sliderValue={betOrRaiseValue}
                maxBet={maxBet}
                callAmount={callAmount}
                minBet={minBet}
                smallBlind={smallBlind}
              />
              <Button
                hidden={!isSliderShown || isDisableAllActions || !isSettingBet}
                onClick={() => {
                  const currentFormValue = new BigNumber(
                    form.getFieldValue(FIELDS.BET_OR_RAISE_VALUE)
                  );
                  const smallBlindAmount = new BigNumber(smallBlind);
                  const minBetAmount = new BigNumber(minBet);

                  if (currentFormValue.minus(smallBlindAmount).lte(minBetAmount)) {
                    form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: minBet});
                    setBetOrRaiseValue(minBet);
                    sheet.update({sliderValue: betOrRaiseValue});
                  } else {
                    const newValue = currentFormValue.minus(smallBlindAmount);
                    form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: newValue});
                    setBetOrRaiseValue(Number(newValue));
                    sheet.update({sliderValue: betOrRaiseValue});
                  }
                }}
                size="small"
                className={classes.minusButton}
              >
                -
              </Button>
              <Button
                hidden={!isSliderShown || isDisableAllActions || !isSettingBet}
                size="small"
                className={classes.plusButton}
                onClick={() => {
                  const currentFormValue = new BigNumber(
                    form.getFieldValue(FIELDS.BET_OR_RAISE_VALUE)
                  );
                  const smallBlindAmount = new BigNumber(smallBlind);
                  const maxBetAmount = new BigNumber(maxBet);

                  if (currentFormValue.plus(smallBlindAmount).gte(maxBetAmount)) {
                    form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: maxBet});
                    setBetOrRaiseValue(maxBet);
                    sheet.update({sliderValue: betOrRaiseValue});
                  } else {
                    const newValue = currentFormValue.plus(smallBlindAmount);
                    form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: newValue});
                    setBetOrRaiseValue(Number(newValue));
                    sheet.update({sliderValue: betOrRaiseValue});
                  }
                }}
              >
                +
              </Button>
              <div
                className={classNames({
                  [classes.hidden]:
                    !isNumpadShown ||
                    isDisableAllActions ||
                    !isSettingBet ||
                    shouldSlideDownButtons,
                })}
              >
                <div className={classes.numpadContainer}>
                  <div className={classes.buttonRow}>
                    <NumpadCrossIcon
                      className={sheet.classes.crossIcon}
                      onClick={() => {
                        setIsNumpadShown(false);
                        setIsSettingBet(false);
                        setSliderToBottom();
                      }}
                    />
                  </div>
                  <div className={classes.numpadRow}>
                    <div>
                      <div className={classes.numpadDisplayRow}>
                        <span
                          className={classNames(classes.dollarSign, {
                            [classes.redWarning]: isWarned,
                          })}
                        >
                          {game.unit === UNIT_TYPE.USD ? '$' : 'BB'}
                        </span>
                        <Statistic // TODO
                          valueStyle={{color: isWarned ? 'red' : 'white', fontSize: '23px'}}
                          className={classes.numpadDisplayField}
                          value={betOrRaiseValue}
                        />
                      </div>
                      <Keyboard
                        keyboardRef={r => {
                          keyboardRef.current = r;
                        }}
                        theme={`hg-theme-default hg-layout-numeric numeric-theme ${classes.numpadTheme}`}
                        // theme={`hg-theme-default hg-layout-numeric numeric-theme ${classes.numpadTheme}`}
                        layoutName="default"
                        onChange={input => {
                          form.setFieldsValue({[FIELDS.BET_OR_RAISE_VALUE]: Number(input)});
                          setBetOrRaiseValue(Number(input));
                          // TODO for validation
                          // calculated are passed in usd unit
                          if (game.unit === UNIT_TYPE.BIG_BLIND) {
                            const bigValue = new BigNumber(Number(input));
                            const bigMultiplier = new BigNumber(game.bigBlind);
                            const calculated = bigValue
                              .multipliedBy(bigMultiplier)
                              .dp(2)
                              .toNumber();
                            setValueToServer(calculated);
                          }
                        }}
                        onKeyPress={button => {
                          if (button === '{clear}') {
                            // keyboardRef.current.setInput('');
                            keyboardRef?.current?.setInput('0');
                            setBetOrRaiseValue(0);
                          }
                        }}
                        disableCaretPositioning
                        maxLength={7}
                        display={{
                          '{clear}': 'C',
                        }}
                        layout={{
                          default: ['1 2 3', '4 5 6', '7 8 9', '0 . {clear}'],
                        }}
                        // inputMask={'(99) 9999-9999'}
                        // modules={[inputMask]}
                        buttonTheme={[
                          {
                            class: `${classes.buttonTheme}`,
                            buttons: '1 2 3 4 5 6 7 8 9 0 . {clear}',
                          },
                        ]} // TODO start with . will have bug
                        inputPattern={/^(\d+)?([.]?\d{0,2})?$/}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {renderBetOrRaise()}
            </motion.div>
          </div>
        </div>
        <div
          className={classNames({
            [classes.hidden]: insuranceInfo?.isTriggered && !isDebugView,
          })}
        >
          {/* todo !isNumpadShown */}
          <Row>
            <Col span={24} className={classes.buttonsColumn}>
              {renderButtons()}
            </Col>
          </Row>
        </div>
      </Form>
      {/* //TODO *** unhide */}
      {insuranceInfo ? (
        <div
          className={classNames(
            (!insuranceInfo?.isTriggered || myPlayer?.id !== insuranceInfo?.advantageousPlayerId) &&
              classes.hidden
          )}
        >
          <InsurancePanel
            insuranceInfo={insuranceInfo}
            closePanel={cancelInsurance}
            confirmInsurance={confirmInsurance}
            expiredAt={insuranceExpireAt}
          />
        </div>
      ) : null}
      <div>
        <CustomPopup
          centered
          maskStyle={{background: 'rgba(74, 78, 86, 0.10)'}}
          width={300}
          open={isFoldPopupVisible}
          buttons={[
            {
              isBlue: true,
              buttonFunction: async () => {
                setIsFoldPopupVisible(false);
                await performPlayerAction({action: PLAYER_ACTION.FOLD});
              },
              buttonLabel: t('common:yes'),
              id: 'confirmFoldYes',
            },
            {
              isBlue: false,
              buttonFunction: () => {
                setIsFoldPopupVisible(false);
              },
              buttonLabel: t('common:no'),
            },
          ]}
          closable={false}
          title={t('confirm_to_fold')}
        />
      </div>
    </>
  );
};

export default React.memo(ActionButtons);
